import { ru, enUS } from 'date-fns/locale';

const userLocale = localStorage.getItem('lang');

const getDateFnsLocale = () => {
  if (userLocale === 'en') return enUS;
  return ru;
};

export const dateFnsLocale = getDateFnsLocale();
